const navToggle = () => {
    let nav = document.querySelector('.page__nav')
    let burg = document.querySelector('.page__burg')
    nav.classList.toggle('hide')
    burg.classList.toggle('show')
}